<template>
  <div class="recharge_left capital_first">
    <el-row class="headerTopBg" style="align-items: center; display: flex">
      <el-col :span="12">
        <h3>{{$t('strategyNow.balance')}}：{{ amountPlus }}元</h3>
      </el-col>
      <el-col :span="12" style="text-align: right">
        <div class="content-flex">
          <router-link
            style="
              background-color: #f46f83;
              color: white;
              border-radius: 7px;
              padding: 8px 15px;
            "
            :to="{ name: 'Protocol', params: { type: 21 } }"
            >{{ $t('friendCoupon.termsAndCondition') }}</router-link
          >
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-table
        :data="all_coupon"
        stripe
        size="mini"
        style="width: 100%; font-size: 16px"
      >
        <el-table-column prop="name" align="center" :label="$t('friendCoupon.giftDate')">
          <template slot-scope="scope">
            <p style="font-size: 15px">{{ scope.row.time }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="short" align="center" :label="$t('friendCoupon.expiry')">
          <template slot-scope="scope">
            <p style="font-size: 15px">{{ scope.row.effect_date }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="number" align="center" :label="$t('friendCoupon.amount')">
          <template slot-scope="scope">
            <p style="font-size: 15px">{{ scope.row.amount }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="surplus" align="center" :label="$t('friendCoupon.state')">
          <template slot-scope="scope">
            <p style="font-size: 15px">{{ scope.row.statustext }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="frozen" align="center" :label="$t('friendCoupon.qr')">
          <template slot-scope="scope">
            <p
              v-if="scope.row.status === 1"
              @click="agencyQr(scope.row.coupon, scope.row.amount)"
            >
              <span
                style="
                  font-size: 15px;
                  color: #606266;
                  font-weight: 600;
                  cursor: pointer;
                "
                >{{ $t('friendCoupon.details') }}></span
              >
            </p>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "friendcoupon",
  data(){
    return{
      all_coupon:[],
      amountPlus : 0
    }
  },
  created() {
    this.$store.state.accountType = 7;
  },
  mounted(){
    this.getAllDepot();
  },
  methods:{
    getAllDepot() {
      let that = this;
      that.$http({
        url: "/app/FriendCoupon/friend_coupon",
        method: "post",
        
      })
        .then(function(res) {
          let resData = res.data;
          if (resData.status == 200) {
            that.all_coupon = resData.data;

            for (let i = 0; i < that.all_coupon.length; i++) {
             if(that.all_coupon[i].status === 1){
               that.amountPlus = that.amountPlus + that.all_coupon[i].amount;
             }
            }
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },

    agencyQr(id,no){
      this.$store.commit("couponAmountCheck", no);
      this.$store.commit("couponNoCheck", id);
      sessionStorage.setItem("friendQrcode",id);
      this.$router.push({
        path: "/myaccount/friendcouponqr"
      });
    }
  },
}
</script>

<style scoped>
.changePage {
  margin-top: 10px;
}
.headerTopBg {
  background-color: #ffffff;
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 18px 20px;
}
.title {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/friendcoupon.vue